import styled from 'styled-components';

import { elevation } from "../Styles/Utils";

const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Container", componentId: "sc-10p05bf-0" })(["top:0;left:0;right:0;bottom:0;position:fixed;z-index:3;overflow-y:auto;", ""],







elevation(3, false));


const Shadow = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Shadow", componentId: "sc-10p05bf-1" })(["position:fixed;top:0;left:0;right:0;bottom:0;z-index:2;pointer-events:none;background-color:rgba(0,0,0,0.8);"]);










const HeaderWrapper = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__HeaderWrapper", componentId: "sc-10p05bf-2" })(["position:relative;"]);



const Content = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Content", componentId: "sc-10p05bf-3" })(["position:relative;overflow-y:auto;"]);




export { Container, Shadow, HeaderWrapper, Content };